const MOBILE_MENU_TOGGLE_ID = "mobileMenuToggle";
const HEADER_AREA_ID = "header_area";

function headerSetup() {

    setupMobileMenu();

}
headerSetup();


function setupMobileMenu() {
    const MOBILE_MENU_TOGGLE_BUTTON = document.getElementById(MOBILE_MENU_TOGGLE_ID);

    MOBILE_MENU_TOGGLE_BUTTON.addEventListener('click', toggleMobileMenu);
}

function toggleMobileMenu () {
    const HEADER_AREA = document.getElementById(HEADER_AREA_ID);
    const MOBILE_MENU_TOGGLE_BUTTON = document.getElementById(MOBILE_MENU_TOGGLE_ID);

    if (HEADER_AREA.classList.contains("mobile-open")) {
        HEADER_AREA.classList.remove("mobile-open");
        MOBILE_MENU_TOGGLE_BUTTON.classList.remove("menu-open");
        HEADER_AREA.setAttribute('aria-expanded', "false");
    } else {
        HEADER_AREA.classList.add("mobile-open");
        MOBILE_MENU_TOGGLE_BUTTON.classList.add("menu-open");
        HEADER_AREA.setAttribute('aria-expanded', "true");
    }
}

export {headerSetup};
